export default function Error() {
  return (
    <div className="flex h-full w-full items-start justify-center bg-light_bg_Main py-3 dark:bg-dark_bg_Main">
      <h1 className="mt-2 text-2xl font-bold text-amber-500 dark:text-indigo-600">
        Something went wrong. Please try again...
      </h1>
    </div>
  );
}
